export default "__VITE_ASSET__CWp5EU_q__"